(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Shop-by-look-new-sd"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-by-look')) {
    class ShopByLook extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sbl__track');
        this.slides = Array.from(this.querySelectorAll('.sbl__slide'));
        if (!this.slides.length) return;
        this.autoplay = this.dataset.autoplay === 'true';
        this.muted = this.dataset.muted !== 'false';
        this.active = -1;
        this.visible = false;

        // ----- Carousel -----
        this.querySelectorAll('.sbl__arrow').forEach((btn) =>
          btn.addEventListener('click', () => this.go(this.active + Number(btn.dataset.dir)))
        );

        this.slides.forEach((slide, i) => {
          const media = slide.querySelector('.sbl__media');
          const card = slide.querySelector('a.sbl__card');
          const open = (e) => {
            if (e.target.closest('.sbl__mute')) return;
            e.preventDefault();
            this.openModal(i);
          };
          media.addEventListener('click', open);
          media.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') open(e);
          });
          if (card) card.addEventListener('click', open);

          const mute = slide.querySelector('.sbl__mute');
          if (mute) mute.addEventListener('click', (e) => {
            e.stopPropagation();
            this.muted = !this.muted;
            this.applyMute(slide);
          });
        });

        let t;
        this.track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => this.setActive(this.closest()), 80);
        }, { passive: true });

        this.io = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          const slide = this.slides[this.active];
          if (!slide || this.isOpen) return;
          this.visible && this.autoplay ? this.play(slide) : this.pause(slide);
        }, { threshold: 0.35 });
        this.io.observe(this);

        const start = Math.min(Number(this.dataset.start) || 0, this.slides.length - 1);
        requestAnimationFrame(() => this.go(start, false));

        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) this.go(i);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        // ----- Lightbox -----
        this.modal = this.querySelector('.sbl-m');
        if (this.modal) {
          document.body.appendChild(this.modal); // escape transformed / overflow-hidden ancestors
          this.bindModal();
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.isOpen) this.closeModal();
        if (this.modal && this.modal.parentNode === document.body) this.modal.remove();
      }

      closest() {
        const r = this.track.getBoundingClientRect();
        const mid = r.left + r.width / 2;
        let best = 0, dist = Infinity;
        this.slides.forEach((s, i) => {
          const b = s.getBoundingClientRect();
          const d = Math.abs(b.left + b.width / 2 - mid);
          if (d < dist) { dist = d; best = i; }
        });
        return best;
      }

      wrap(i) { const n = this.slides.length; return ((i % n) + n) % n; }

      go(i, smooth = true) {
        i = this.wrap(i);
        const slide = this.slides[i];
        const left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
        this.setActive(i);
      }

      setActive(i) {
        if (i === this.active) return;
        const prev = this.slides[this.active];
        if (prev) { prev.classList.remove('is-active'); this.pause(prev); }
        this.active = i;
        const slide = this.slides[i];
        slide.classList.add('is-active');
        this.applyMute(slide);
        if (this.autoplay && this.visible && !this.isOpen) this.play(slide);
      }

      video(slide) { return slide.querySelector('video'); }

      play(slide) {
        const v = this.video(slide);
        if (!v) return;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
        slide.classList.add('is-playing');
      }

      pause(slide) {
        const v = this.video(slide);
        if (v) { v.pause(); v.muted = true; }
        slide.classList.remove('is-playing', 'is-unmuted');
      }

      applyMute(slide) {
        const v = this.video(slide);
        if (!v) return;
        v.muted = this.muted;
        slide.classList.toggle('is-unmuted', !this.muted);
      }

      // ================= Lightbox =================
      bindModal() {
        const m = this.modal;
        this.mMedia = m.querySelector('.sbl-m__media');
        this.mVideoBox = m.querySelector('.sbl-m__video');
        this.mTitle = m.querySelector('.sbl-m__title');
        this.mPanel = m.querySelector('.sbl-m__panel');
        this.mToast = m.querySelector('.sbl-m__toast');

        m.querySelector('.sbl-m__close').addEventListener('click', () => this.closeModal());
        m.querySelectorAll('.sbl-m__nav').forEach((b) =>
          b.addEventListener('click', () => this.showLook(this.mIndex + Number(b.dataset.dir)))
        );
        m.addEventListener('click', (e) => { if (e.target === m) this.closeModal(); });

        m.querySelector('.sbl-m__mute').addEventListener('click', (e) => {
          e.stopPropagation();
          this.muted = !this.muted;
          this.syncModalMute();
        });
        m.querySelector('.sbl-m__share').addEventListener('click', (e) => {
          e.stopPropagation();
          this.share();
        });

        this.mVideoBox.addEventListener('click', (e) => {
          if (e.target.closest('button')) return;
          const v = this.mMedia.querySelector('video');
          if (!v) return;
          if (v.paused) { v.play().catch(() => {}); this.mVideoBox.classList.remove('is-paused'); }
          else { v.pause(); this.mVideoBox.classList.add('is-paused'); }
        });

        // Swipe: left/right or up/down moves between looks (phones)
        let sx = 0, sy = 0;
        this.mVideoBox.addEventListener('touchstart', (e) => {
          sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        }, { passive: true });
        this.mVideoBox.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - sx;
          const dy = e.changedTouches[0].clientY - sy;
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 50) return;
          const dir = Math.abs(dx) > Math.abs(dy) ? (dx < 0 ? 1 : -1) : (dy < 0 ? 1 : -1);
          this.showLook(this.mIndex + dir);
        }, { passive: true });

        this.onKey = (e) => {
          if (!this.isOpen) return;
          if (e.key === 'Escape') this.closeModal();
          else if (e.key === 'ArrowRight') this.showLook(this.mIndex + 1);
          else if (e.key === 'ArrowLeft') this.showLook(this.mIndex - 1);
          else if (e.key === 'Tab') this.trapFocus(e);
        };
      }

      openModal(i) {
        if (!this.modal) return;
        this.lastFocus = document.activeElement;
        this.isOpen = true;
        this.slides.forEach((s) => this.pause(s));
        this.modal.hidden = false;
        document.documentElement.classList.add('sbl-lock');
        document.addEventListener('keydown', this.onKey);
        this.showLook(i);
        requestAnimationFrame(() => {
          this.modal.classList.add('is-open');
          this.modal.querySelector('.sbl-m__close').focus({ preventScroll: true });
        });
      }

      closeModal() {
        if (!this.isOpen) return;
        this.isOpen = false;
        const v = this.mMedia.querySelector('video');
        if (v) v.pause();
        this.mMedia.innerHTML = '';
        this.modal.classList.remove('is-open');
        this.modal.hidden = true;
        document.documentElement.classList.remove('sbl-lock');
        document.removeEventListener('keydown', this.onKey);
        this.go(this.mIndex, false);
        const slide = this.slides[this.active];
        if (slide && this.autoplay && this.visible) this.play(slide);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }

      showLook(i) {
        i = this.wrap(i);
        this.mIndex = i;
        const slide = this.slides[i];

        // Video: clone the slide's media so we reuse Shopify's responsive sources
        const old = this.mMedia.querySelector('video');
        if (old) old.pause();
        this.mMedia.innerHTML = '';
        const src = slide.querySelector('.sbl__media video, .sbl__media img, .sbl__media svg');
        if (src) {
          const clone = src.cloneNode(true);
          clone.removeAttribute('class');
          this.mMedia.appendChild(clone);
          if (clone.tagName === 'VIDEO') {
            clone.loop = true;
            clone.playsInline = true;
            clone.setAttribute('playsinline', '');
            clone.preload = 'auto';
            clone.currentTime = 0;
            clone.muted = this.muted;
            const p = clone.play();
            if (p && p.catch) p.catch(() => { clone.muted = true; this.muted = true; this.syncModalMute(); clone.play().catch(() => {}); });
          }
        }
        this.mVideoBox.classList.remove('is-paused');
        this.modal.querySelector('.sbl-m__mute').hidden = !this.mMedia.querySelector('video');
        this.syncModalMute();

        // Title + product panel
        const tpl = slide.querySelector('.sbl__tpl');
        this.mTitle.textContent = tpl ? tpl.dataset.title : '';
        this.shareUrl = tpl ? tpl.dataset.share : location.href;
        this.mPanel.innerHTML = '';
        if (tpl) this.mPanel.appendChild(tpl.content.cloneNode(true));
        this.mPanel.classList.remove('is-expanded');
        this.initGallery();
        this.initSheet();

        const multi = this.slides.length > 1;
        this.modal.querySelectorAll('.sbl-m__nav').forEach((b) => (b.hidden = !multi));
      }

      initSheet() {
        const panel = this.mPanel;
        const body = panel.querySelector('.sbl-m__body');
        const handle = panel.querySelector('.sbl-m__handle');
        if (body) body.scrollTop = 0;
        const expand = (on) => {
          panel.classList.toggle('is-expanded', on);
          if (handle) handle.setAttribute('aria-label', on ? 'Show less' : 'Show more details');
        };
        if (handle) handle.addEventListener('click', () => expand(!panel.classList.contains('is-expanded')));
        // On phones, scrolling into the details grows the sheet; scrolling back to top shrinks it
        if (body) body.addEventListener('scroll', () => {
          if (!handle || getComputedStyle(handle).display === 'none') return;
          if (body.scrollTop > 24 && !panel.classList.contains('is-expanded')) expand(true);
        }, { passive: true });
        // Keep swipe gestures inside the sheet from changing the look
        panel.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: true });
        panel.addEventListener('touchend', (e) => e.stopPropagation(), { passive: true });
      }

      syncModalMute() {
        const v = this.mMedia && this.mMedia.querySelector('video');
        if (v) v.muted = this.muted;
        this.mVideoBox.classList.toggle('is-unmuted', !this.muted);
      }

      initGallery() {
        const track = this.mPanel.querySelector('.sbl-m__imgs');
        if (!track) return;
        const items = Array.from(track.children);
        const next = this.mPanel.querySelector('.sbl-m__gnext');
        const dotsWrap = this.mPanel.querySelector('.sbl-m__dots');
        const pages = () => Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth));

        const renderDots = () => {
          if (!dotsWrap) return;
          const n = pages();
          dotsWrap.innerHTML = n > 1 ? '<span></span>'.repeat(n) : '';
          update();
        };
        const update = () => {
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          if (next) next.hidden = track.scrollWidth <= track.clientWidth + 4;
          if (next) next.style.transform = atEnd ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)';
          if (!dotsWrap) return;
          const n = dotsWrap.children.length;
          const p = atEnd ? n - 1 : Math.round(track.scrollLeft / track.clientWidth);
          Array.from(dotsWrap.children).forEach((d, k) => d.classList.toggle('is-on', k === p));
        };

        if (next) next.addEventListener('click', () => {
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          const step = items[0] ? items[0].offsetWidth + 12 : track.clientWidth;
          track.scrollBy({ left: atEnd ? -track.scrollWidth : step, behavior: 'smooth' });
        });
        track.addEventListener('scroll', update, { passive: true });
        requestAnimationFrame(renderDots);
      }

      async share() {
        const url = this.shareUrl || location.href;
        try {
          if (navigator.share) { await navigator.share({ title: document.title, url }); return; }
          await navigator.clipboard.writeText(url);
          this.toast('Link copied');
        } catch (e) { /* user cancelled */ }
      }

      toast(msg) {
        this.mToast.textContent = msg;
        this.mToast.classList.add('is-on');
        clearTimeout(this.toastT);
        this.toastT = setTimeout(() => this.mToast.classList.remove('is-on'), 1600);
      }

      trapFocus(e) {
        const f = Array.from(this.modal.querySelectorAll('button:not([hidden]), a[href], select, [tabindex]:not([tabindex="-1"])'))
          .filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    customElements.define('shop-by-look', ShopByLook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isha-curated-for-you"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('isha-curated-products')) {
  customElements.define('isha-curated-products', class extends HTMLElement {
    static normalize(value) { return String(value || '').trim().toLowerCase(); }
    static list(value) { return String(value || '').split(/[,\n]/).map(this.normalize).filter(Boolean); }
    static rule(config) {
      const norm = this.normalize;
      const rules = config.rules.filter(rule => rule.enabled && (!rule.sourceTag || config.tags.some(tag => norm(tag) === norm(rule.sourceTag))));
      return rules.find(rule => rule.sourceId === config.id) || rules.find(rule => !rule.sourceId && this.list(rule.sourceTypes).includes(norm(config.type)));
    }
    static eligible(item, config, rule) {
      const norm = this.normalize;
      return item.available && item.id !== config.id && !config.cartIds.includes(item.id) && Number.isFinite(item.price) && item.price >= Math.ceil(config.price * (100 - config.below) / 100) && item.price <= Math.floor(config.price * (100 + config.above) / 100) && (!config.differentType || norm(item.type) !== norm(config.type)) && (!rule.requiredTag || item.tags.some(tag => norm(tag) === norm(rule.requiredTag)));
    }
    static rank(items, config, rule, excluded = new Set()) {
      const unique = new Map();
      for (const item of items) {
        if (!this.eligible(item, config, rule) || excluded.has(item.id)) continue;
        const previous = unique.get(item.id);
        if (!previous || item.priority < previous.priority || (item.priority === previous.priority && item.manualOrder < previous.manualOrder)) unique.set(item.id, item);
      }
      return [...unique.values()].sort((a, b) => a.priority - b.priority || (a.manualOrder ?? 999) - (b.manualOrder ?? 999) || Math.abs(a.price - config.price) - Math.abs(b.price - config.price) || a.price - b.price || a.id.localeCompare(b.id));
    }
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.controller = new AbortController();
      this.config = JSON.parse(this.querySelector('[data-curated-config]').textContent);
      this.rule = this.constructor.rule(this.config);
      if (!this.rule) { this.status('No enabled rule matches this product type.', 'unmatched'); return; }
      this.dataset.rule = this.rule.title;
      this.load();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    status(message, state) {
      this.dataset.state = state;
      const status = this.parentElement.querySelector('[data-curated-status]');
      if (status) status.textContent = 'Curated for you: ' + message;
    }
    async request(path) {
      const url = new URL(path, location.origin);
      if (url.origin !== location.origin) throw new Error('Cross-sell URL must belong to this store');
      url.searchParams.set('section_id', 'isha-cross-sell-data');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) throw new Error('Cross-sell request failed: ' + response.status);
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = document.querySelector('[data-cross-sell-data]');
      if (!data) throw new Error('Cross-sell data section is missing');
      return { ...JSON.parse(data.textContent), card: document.querySelector('[data-cross-sell-card]') };
    }
    async collection(path, priority, expectedType) {
      let next = new URL(path, location.origin);
      next.searchParams.set('filter.v.availability', '1');
      if (this.config.currency === this.config.baseCurrency) {
        next.searchParams.set('filter.v.price.gte', (Math.ceil(this.config.price * (100 - this.config.below) / 100) / 100).toFixed(2));
        next.searchParams.set('filter.v.price.lte', (Math.floor(this.config.price * (100 + this.config.above) / 100) / 100).toFixed(2));
      }
      const seen = new Set();
      const items = [];
      while (next) {
        if (seen.has(next.href)) throw new Error('Cross-sell pagination repeated');
        seen.add(next.href);
        const result = await this.request(next.href);
        for (const item of result.products) {
          if (!expectedType || this.constructor.normalize(item.type) === expectedType) items.push({ ...item, priority });
        }
        next = result.next ? new URL(result.next, next) : null;
      }
      return items;
    }
    static async parallel(items, action, limit = 4) {
      const results = new Array(items.length);
      let cursor = 0;
      await Promise.all(Array.from({ length: Math.min(limit, items.length) }, async () => {
        while (cursor < items.length) { const index = cursor++; results[index] = await action(items[index], index); }
      }));
      return results;
    }
    async selectCards(items, selected, typeCounts, attempted) {
      const excluded = new Set();
      for (const link of document.querySelectorAll('isha-similar-products a[href*="/products/"]')) {
        const path = new URL(link.href).pathname;
        for (const item of items) if (new URL(item.url, location.origin).pathname === path) excluded.add(item.id);
      }
      const ranked = this.constructor.rank(items, this.config, this.rule, excluded);
      while (selected.length < this.config.count) {
        const reserved = new Map(typeCounts);
        const batch = [];
        for (const item of ranked) {
          const type = this.constructor.normalize(item.type);
          if (attempted.has(item.id) || (reserved.get(type) || 0) >= this.config.perType) continue;
          attempted.add(item.id);
          reserved.set(type, (reserved.get(type) || 0) + 1);
          batch.push(item);
          if (batch.length >= this.config.count - selected.length) break;
        }
        if (!batch.length) break;
        const results = await this.constructor.parallel(batch, item => this.cards.get(item.id) || this.request(item.url));
        results.forEach((result, index) => {
          const live = result.products[0];
          if (!result.card || !live || live.id !== batch[index].id || !this.constructor.eligible(live, this.config, this.rule)) return;
          const type = this.constructor.normalize(live.type);
          if ((typeCounts.get(type) || 0) >= this.config.perType) return;
          selected.push({ ...result, selection: { ...batch[index], ...live } });
          typeCounts.set(type, (typeCounts.get(type) || 0) + 1);
        });
      }
    }
    async load() {
      this.status('Loading ' + this.rule.title + '.', 'loading');
      const items = [];
      this.cards = new Map();
      const selected = [];
      const typeCounts = new Map();
      const attempted = new Set();
      const started = performance.now();
      try {
        if (this.rule.mode !== 'automatic') {
          const results = await this.constructor.parallel(this.rule.manual, url => this.request(url));
          results.forEach((result, index) => {
            const item = result.products[0];
            if (item) { items.push({ ...item, priority: 0, manualOrder: index }); this.cards.set(item.id, result); }
          });
          await this.selectCards(items, selected, typeCounts, attempted);
        }
        if (this.rule.mode !== 'manual' && selected.length < this.config.count) {
          const sources = [];
          const catalog = this.config.catalog;
          const sourceUrls = new Set();
          const add = (url, priority, type) => { if (url && !sourceUrls.has(url)) { sourceUrls.add(url); sources.push({ url, priority, type }); } };
          if (this.rule.collection) add(this.rule.collection, 1, null);
          const groups = [this.rule.priorityOne, this.rule.priorityTwo, this.rule.fallback ? this.rule.sourceTypes : ''];
          for (const [group, types] of groups.entries()) {
            for (const name of this.constructor.list(types)) {
              if (this.config.differentType && name === this.constructor.normalize(this.config.type)) continue;
              const type = catalog.find(entry => this.constructor.normalize(entry.type) === name);
              if (type) add(type.url, group + 1, name);
            }
          }
          for (const priority of [1, 2, 3]) {
            const group = sources.filter(source => source.priority === priority);
            const results = await this.constructor.parallel(group, source => this.collection(source.url, source.priority, source.type));
            await this.selectCards(results.flat(), selected, typeCounts, attempted);
            if (selected.length >= this.config.count) break;
          }
        }
        if (!this.isConnected || this.controller.signal.aborted) return;
        if (!selected.length) { this.status('No available products meet this rule and price range.', 'empty'); return; }
        const order = new Map(this.constructor.rank(selected.map(result => result.selection), this.config, this.rule).map((item, index) => [item.id, index]));
        selected.sort((a, b) => order.get(a.products[0].id) - order.get(b.products[0].id));
        const fragment = this.querySelector('[data-curated-layout]').content.cloneNode(true);
        const container = fragment.querySelector('[data-curated-items]');
        selected.forEach(result => container.append(result.card.content.cloneNode(true)));
        if (selected.length <= 4) fragment.querySelector('prev-next-buttons').remove();
        this.hidden = false;
        this.replaceChildren(fragment);
        this.dataset.productIds = selected.map(result => result.products[0].id).join(',');
        this.dataset.loadMs = String(Math.round(performance.now() - started));
        this.status(selected.length + ' products from ' + this.rule.title + '.', 'ready');
      } catch (error) {
        if (error.name !== 'AbortError') { this.status('Unable to load products. Check the rule and reload.', 'error'); console.warn('ISHA curated products:', error); }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('isha-similar-products')) {
    customElements.define('isha-similar-products', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.controller = new AbortController();
        this.loadMatches();
      }
      disconnectedCallback() { this.controller?.abort(); }
      async loadMatches() {
        const normalize = value => String(value || '').trim().toLocaleLowerCase();
        const type = normalize(this.dataset.type);
        const color = normalize(this.dataset.color);
        const price = Number(this.dataset.price);
        const tolerance = Number(this.dataset.tolerance || 20);
        if (!type || !color || !Number.isFinite(price)) return;
        const min = Math.ceil(price * (100 - tolerance) / 100);
        const max = Math.floor(price * (100 + tolerance) / 100);
        const count = Math.max(1, Math.min(25, Number(this.dataset.count) || 4));
        const matches = new Map();
        const visited = new Set();
        let next = new URL(this.dataset.source, location.origin);
        next.searchParams.set('section_id', 'product-recommendations');
        next.searchParams.set('filter.v.availability', '1');
        if (this.dataset.currency === this.dataset.baseCurrency) {
          next.searchParams.set('filter.v.price.gte', (min / 100).toFixed(2));
          next.searchParams.set('filter.v.price.lte', (max / 100).toFixed(2));
        }
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) next.searchParams.set('preview_theme_id', preview);
        try {
          while (next) {
            if (next.origin !== location.origin || visited.has(next.href)) throw new Error('Invalid similar-products pagination');
            visited.add(next.href);
            const response = await fetch(next.href, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Similar-products request failed: ' + response.status);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const result = doc.querySelector('[data-isha-candidates]');
            if (!result) throw new Error('Missing similar-products results');
            for (const candidate of result.querySelectorAll('template[data-isha-candidate]')) {
              const data = candidate.dataset;
              const candidatePrice = Number(data.price);
              if (data.id !== this.dataset.id && normalize(data.type) === type && normalize(data.color) === color && candidatePrice >= min && candidatePrice <= max) {
                matches.set(data.id, { template: candidate, price: candidatePrice, id: data.id, ratio: Number(data.ratio) || 1 });
              }
            }
            next = result.dataset.next ? new URL(result.dataset.next, next) : null;
            if (next) {
              next.searchParams.set('section_id', 'product-recommendations');
              if (preview) next.searchParams.set('preview_theme_id', preview);
            }
          }
          if (!this.isConnected) return;
          const selected = [...matches.values()].sort((a, b) => Math.abs(a.price - price) - Math.abs(b.price - price) || a.price - b.price || a.id.localeCompare(b.id)).slice(0, count);
          this.dataset.matchCount = String(matches.size);
          this.dataset.state = selected.length ? 'ready' : 'empty';
          if (!selected.length) return;
          const fragment = this.querySelector('[data-isha-layout]').content.cloneNode(true);
          const items = fragment.querySelector('[data-isha-items]');
          selected.forEach(item => items.append(item.template.content.cloneNode(true)));
          const arrows = fragment.querySelector('prev-next-buttons');
          if (selected.length <= 4) arrows.remove();
          else arrows.style.setProperty('--smallest-image-aspect-ratio', Math.max(...selected.map(item => item.ratio)));
          this.hidden = false;
          this.replaceChildren(fragment);
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.dataset.state = 'error';
            console.warn('ISHA similar products:', error);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
